
<template>
  <div class="wrapper">
    <div class="content">
      <div class="company-form">
        <!-- form header  -->
        <!-- <div class="header">
          <img
            src="@/assets/images/logo-lg.svg"
            class="unselectable"
            alt
            width="20%"
          />
          <p class="company-title">Company Dashboard</p>
          <p class="company-subtitle">
            Create
          </p>
        </div> -->
        <div class="modal-main-header">
          <div>
            <p class="company-title">Company Dashboard</p>
            <p class="company-subtitle">
              Create
            </p>
          </div>
            <svg
            class="header-close"
            @click="$bvModal.hide('createCompany')"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
              fill="#F46A6A"
            />
          </svg>
        </div>
        <!-- form tabs  -->
        <form-wizard
          class="custom-form-wizard custom-form-wizard-entity"
          color="#103F5E"
          step-size="sm"
        >
          <!-- Step 1  -->
          <tab-content :before-change="beforeTabOneSwitch">
            <p class="company-details">Company details</p>
            <!-- name   -->
            <div class="user-name company-input">
              <div class="input-wrapper">
                <div
                  class="form-group m-d-gruop"
                  :class="$v.entity.name.$error && 'invalid-value'"
                >
                  <b-form-input v-model="entity.name" type="text" required maxlength="50"/>
                  <label for="phone">Company Name</label>
                </div>
              </div>
              <div class="err-wrapper">
                <div v-if="submitted && !$v.entity.name.required">
                  <span class="error-value"> Name is required.</span>
                </div>
                <div v-else-if="submitted && !$v.entity.name.maxLength">
                  <span class="error-value"
                    >The maximum length is 50 characters.</span
                  >
                </div>
              </div>
            </div>
          <!-- Server -->
          <div class="company-input select-server">
            <div
              class="input-wrapper multiselect-container"
              :class="$v.server.$error && 'invalid-value mb-8'"
            >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="multi-select-placeholder-icon"
            >
              <path
                d="M13.7467 15C14.0674 15 14.3884 14.8777 14.6329 14.6328C15.1224 14.1435 15.1224 13.3498 14.6329 12.8603L11.586 9.8135C13.2154 7.3595 12.9497 4.00983 10.7883 1.8485C8.32362 -0.616167 4.31323 -0.616167 1.84853 1.8485C-0.616175 4.31317 -0.616175 8.3235 1.84853 10.7883C3.08088 12.0207 4.69973 12.6368 6.31842 12.6368C7.53877 12.6368 8.75879 12.2863 9.81364 11.586L12.8605 14.6328C13.105 14.8777 13.4259 15 13.7467 15ZM3.40305 9.23367C1.79569 7.62633 1.79569 5.01083 3.40305 3.4035C4.20673 2.59983 5.26257 2.19783 6.31825 2.19783C7.37394 2.19783 8.42978 2.59967 9.23363 3.4035C10.841 5.01083 10.841 7.62633 9.23363 9.23367C7.62611 10.841 5.01057 10.841 3.40305 9.23367Z"
                fill="#787878"
              />
            </svg>
            <!-- <span
              v-if="server"
              :class="{'ml-51 mt-12': server }"
              class="multiselect-title custom-multiselect-title"
              >Server
            </span> -->
              <multiselect
                id="server"
                class="custom-multi-select"
                :class="{'hide-placeholder': !server }"
                v-model="server"
                :options="servers"
                placeholder="Server"
                :show-labels="false"
                :allowEmpty="true"
                @select="changeServerVal"
                @deselect="changeServerVal"
              >
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span
                      class="option__name font-weight-bold"
                      >{{ props.option.server_name }} ({{ props.option.notes }})</span
                    >
                  </div>
                </template>

                <template slot="singleLabel" slot-scope="{ option }">
                  <div class="option__desc">
                    <span
                      class="option__name font-weight-bold"
                      >{{ option.server_name }} ({{ option.notes }})</span
                    >
                  </div>
                </template>
              </multiselect>
            </div>
            <div class="err-wrapper" v-if="submitted && !$v.server.required">
              <span class="error-value"> Server is required.</span>
            </div>
          </div>
          <!-- subdomain  -->
          <div class="user-subdomain company-input">
            <div class="input-wrapper">
              <div class="row-group phone-group justify-content-start w-100 h-55">
                <div
                  class="form-group m-d-gruop w-100 mb-0 subdomain-input"
                  :class=" server && subdomainValue ? $v.subdomainValue.required && $v.subdomainValue.minLength && $v.subdomainValue.maxLength
                  && $v.subdomainValue.validCharacters && $v.subdomainValue.containsSpace
                  && $v.subdomainValue.containsHyphenAtStart && $v.subdomainValue.containsDoubleHyphen && ( subdomainInputValid === true || subdomainInputValid === null)?
                    '' :'invalid-value-subdomain mb-8' : ''"
                >
                  <b-form-input
                    id="subdomain"
                    autocomplete="off"
                    :disabled="!server"
                    v-model="subdomainValue"
                    type="text"
                    required
                    autofocus
                    name="subdomain"
                    @keypress="onSubdomainInputTyping"
                    @paste="onSubdomainInputPaste"
                    @input="$v.subdomainValue.$touch()"
                  />
                  <label for="subdomain" :class="server ? 'subdomain-label' : 'disabled-subdomain-input'">Subdomain</label>
                </div>
                <div class="subdomain-server m-d-gruop" v-if="server" :class=" server && subdomainValue ? $v.subdomainValue.required && $v.subdomainValue.minLength && $v.subdomainValue.maxLength
                  && $v.subdomainValue.validCharacters && $v.subdomainValue.containsSpace
                  && $v.subdomainValue.containsHyphenAtStart && $v.subdomainValue.containsDoubleHyphen && ( subdomainInputValid === true || subdomainInputValid === null)?
                    '' :'invalid-value-subdomain-name mb-8' : ''">
                  <p class="mb-0">{{ subdomain }}</p>
                </div>
              </div>
            </div>
            <div  class="d-flex" :class="server ? 'subdomain-requirements-container' : 'disabled-subdomain-requirements-container'" >
              <svg
                id="subdomainContainer"
                width="16"
                height="16"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="subdomain-requirements-icon"
                v-b-tooltip
              >
                <path
                  d="M8.49904 5.41102e-08C6.81794 0.00018973 5.17466 0.498867 3.77697 1.43297C2.37928 2.36708 1.28996 3.69466 0.646766 5.24785C0.00356934 6.80103 -0.164642 8.51007 0.163441 10.1588C0.491523 11.8076 1.30114 13.3221 2.48992 14.5107C3.67871 15.6994 5.19327 16.5088 6.84208 16.8367C8.49089 17.1646 10.1999 16.9962 11.753 16.3529C13.3061 15.7095 14.6336 14.62 15.5676 13.2222C16.5015 11.8244 17 10.1811 17 8.49998C17 7.38367 16.7801 6.27828 16.3529 5.24696C15.9256 4.21563 15.2995 3.27855 14.5101 2.48924C13.7207 1.69993 12.7835 1.07385 11.7521 0.646742C10.7208 0.219634 9.61535 -0.000125898 8.49904 5.41102e-08ZM9.61057 12.9471C9.61057 13.2419 9.49347 13.5246 9.28502 13.733C9.07657 13.9415 8.79383 14.0586 8.49904 14.0586C8.20424 14.0586 7.92151 13.9415 7.71306 13.733C7.5046 13.5246 7.38751 13.2419 7.38751 12.9471V7.67234C7.38751 7.37754 7.5046 7.09481 7.71306 6.88635C7.92151 6.6779 8.20424 6.56079 8.49904 6.56079C8.79383 6.56079 9.07657 6.6779 9.28502 6.88635C9.49347 7.09481 9.61057 7.37754 9.61057 7.67234V12.9471ZM8.49904 5.16732C8.27976 5.16675 8.06555 5.10127 7.88342 4.97914C7.7013 4.85702 7.55939 4.68371 7.47561 4.48107C7.39183 4.27842 7.36991 4.05551 7.41262 3.84043C7.45534 3.62534 7.56078 3.42773 7.71563 3.27247C7.87049 3.11722 8.06784 3.01127 8.28281 2.968C8.49778 2.92474 8.72073 2.94609 8.9236 3.02935C9.12646 3.11261 9.30013 3.25405 9.42273 3.43586C9.54532 3.61767 9.61136 3.83171 9.6125 4.05099C9.61313 4.19748 9.58476 4.34264 9.52905 4.47812C9.47335 4.61361 9.39138 4.73673 9.28789 4.8404C9.18439 4.94407 9.06141 5.02625 8.92602 5.08219C8.79064 5.13813 8.64553 5.16673 8.49904 5.16635V5.16732Z"
                  :fill=" server && subdomainValue ? $v.subdomainValue.required && $v.subdomainValue.minLength && $v.subdomainValue.maxLength
                  && $v.subdomainValue.validCharacters && $v.subdomainValue.containsSpace
                  && $v.subdomainValue.containsHyphenAtStart && $v.subdomainValue.containsDoubleHyphen && subdomainInputValid !== false ?   '#787878' :  '#F46A6A' : server ? '#787878' : '#C1C1C1'"
                />
              </svg>

              <span :class="server ? 'subdomain-requirements-label' : 'disabled-subdomain-label'"

              v-if="!server || !subdomainValue"
              >Subdomain requirements</span>

              <!-- CL-18308: one message per cause.

                   This used to be a v-else-if whose condition ANDed every
                   format rule together with `subdomainInputValid !== false`,
                   falling through to a single v-else that said "Invalid
                   subdomain format." for ALL of them. So an already-taken
                   subdomain -- well-formed, just not free -- was reported as a
                   malformed one. The three causes are now three messages, and
                   `reserved` is distinct from both rather than being reported
                   as either. See the `subdomainIssueMessage` computed. -->
              <span :class="server ? 'subdomain-requirements-label' : 'disabled-subdomain-label'"
              v-else-if="!subdomainIssueMessage"
              >Subdomain requirements</span>

              <span v-else class="subdomain-requirements-label-error">{{ subdomainIssueMessage }}</span>


            </div>
            <b-tooltip
                placement="bottomleft"
                target="subdomainContainer"
                triggers="click blur"
              >
                <div class="subdomain-requirements">
                    <span class="subdomain-requirements-title">Subdomain requirements:</span>  
                    <div class="subdomain-requirements-items-container">
                      <span class="subdomain-requirements-item"
                      :class="{'failure-requirements-item': subdomainInputTyping && subdomainValue &&  subdomainValue.length > 0 && (!$v.subdomainValue.required || !$v.subdomainValue.minLength || !$v.subdomainValue.maxLength) , 
                      'success-requirements-item': subdomainInputTyping &&  subdomainValue && subdomainValue.length > 0 && $v.subdomainValue.required && $v.subdomainValue.minLength && $v.subdomainValue.maxLength}">
                      - Must be 3 to 63 characters long. 
                    </span>
                    <hr class="subdomain-requirements-hr" />

                      <span class="subdomain-requirements-item"
                        :class="{'failure-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && !$v.subdomainValue.validCharacters , 
                        'success-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && $v.subdomainValue.validCharacters}">
                        - Use only lowercase letters (a-z), numbers (0-9), and hyphens (-). 
                      </span>
                      <hr class="subdomain-requirements-hr" />

                      <span class="subdomain-requirements-item" 
                        :class="{'failure-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && !$v.subdomainValue.containsSpace , 
                        'success-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && $v.subdomainValue.containsSpace}">
                        - Cannot contain spaces or special characters (@, #, $, %, etc.).
                      </span>

                      <hr class="subdomain-requirements-hr" />
                      <span class="subdomain-requirements-item"
                      :class="{'failure-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && !$v.subdomainValue.containsHyphenAtStart , 
                        'success-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && $v.subdomainValue.containsHyphenAtStart}">
                        - Cannot start or end with a hyphen. 
                      </span>
                      <hr class="subdomain-requirements-hr" />
                      <span class="subdomain-requirements-item" :class="{'failure-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && !$v.subdomainValue.containsDoubleHyphen , 
                        'success-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && $v.subdomainValue.containsDoubleHyphen}">
                        - No consecutive hyphens (e.g., my--subdomain is not allowed).
                      </span>
                      <hr class="subdomain-requirements-hr" />

                      <!-- CL-18308: the uniqueness requirement must only go
                           red for a name somebody actually HOLDS. It used to
                           fire on any unavailable answer, so a reserved name
                           lit up "already taken subdomains are not allowed" --
                           reporting a reserved name as taken, which is the
                           same wrong-message bug this ticket is about, one
                           layer down. Reserved has its own line below. -->
                      <span class="subdomain-requirements-item"
                      :class="{'failure-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && subdomainInputValid === false && subdomainUnavailableReason !== 'reserved' ,
                       'success-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && subdomainInputValid === true }">
                       - Must be unique (already taken subdomains are not allowed).
                      </span>
                      <hr class="subdomain-requirements-hr" />

                      <span class="subdomain-requirements-item"
                      :class="{'failure-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && subdomainUnavailableReason === 'reserved' ,
                       'success-requirements-item': subdomainInputTyping && subdomainValue && subdomainValue.length > 0 && subdomainInputValid === true }">
                       - Cannot be a name reserved for VisiPoint's own hostnames.
                      </span>

                    </div>
                </div>
              </b-tooltip>
            <!-- <div class="err-wrapper"> -->
              <!-- <div v-if="subdomainInputTyping && !$v.subdomainValue.required">
                <span class="error-value">Subdomain is required.</span>
              </div> -->
              <!-- <div v-else-if="subdomainInputTyping && $v.subdomainValue.containsSpace">
                  <span class="error-value">Subdomain should not includes any spaces.</span>
              </div> -->
              <!-- CL-18308: two commented-out branches used to sit here, one
                   reading "Subdomain is not valid." and one reading "Subdomain
                   is already used." They are removed rather than left in
                   place, because they are the fossil of exactly the behaviour
                   this ticket asks for: the taken/malformed distinction DID
                   exist on this screen, was disabled, and the live markup then
                   collapsed both into a single format message. The distinction
                   is now live again above, driven by
                   src/utils/subdomainFeedback.js, so leaving a dead copy that
                   describes a different mechanism would only mislead. (It also
                   still exists, uncommented, in
                   modal/CreateCompanyModal.vue.) -->
            <!-- </div> -->
          </div>

            <!-- phone  -->
            <div class="company-input">
              <div class="input-wrapper">
                <div class="row-group w-100">
                  <VueCountryCode
                    class="country-code-input"
                    :disabledFetchingCountry="false"
                    @onSelect="onSelectCompanyCountryCode"
                    :enabledCountryCode="true"
                    :preferredCountries="['GB', 'US', 'CN']"
                  />
                  <div class="form-group m-d-gruop">
                    <b-form-input
                      id="phone"
                      v-model.trim="entity.company_phone"
                      type="number"
                      required
                    />
                    <label for="phone">Company Phone (Optional)</label>
                  </div>
                </div>
              </div>
              <div class="err-wrapper">
                <div v-if="submitted && !$v.entity.company_phone.numeric">
                  <span class="error-value">
                    Phone number should contain only digits.
                  </span>
                </div>
              </div>
            </div>
            <!-- entity checkbox  -->
            <div class="custom-entity-checkbox" >
              <b-form-checkbox  id="UpdateCloudFromEmailCheckbox" v-model="terms_and_conditions" >
                <span class="ml-9" :class="{'custom-entity-checkbox-checked':terms_and_conditions}">I agree to</span> <a target="_blank" href="https://www.visipoint.net/privacy-policy" class="redirect-login">Privacy Policy</a> 
                <span :class="{'custom-entity-checkbox-checked':terms_and_conditions}"> and </span> <a target="_blank" href="https://www.visipoint.net/terms-and-conditions-of-sale" class="redirect-login">Terms and Conditions</a
                    >
              </b-form-checkbox>
            </div>
          </tab-content>
          <!-- Step 2  -->
          <!-- <tab-content :before-change="beforeTabTwoSwitch"> -->

            <!-- <div class="company-input select-device">
              <div class="input-wrapper">
                    <multiselect v-model="typeValue" :options="typeOptions" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Choose device type" class="custom-multi-select"></multiselect>
              </div>
            </div> -->

            <!-- <div id="doorContainer" v-show="this.typeValue=='Door'">
              <p class="company-details">Door details</p>
              <div class="row-group">
                <div class="android-serial company-input">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop" :class="$v.door.name.$error && 'invalid-value'">
                      <b-form-input v-model="door.name" type="text" />
                      <label for="phone">Door Name</label>
                    </div>
                  </div>
                </div>
              </div>
            <div class="row-group">
              <div class="android-serial company-input">
                <div class="input-wrapper">
                  <div class="form-group m-d-gruop" :class="$v.door.id.$error && 'invalid-value'">
                    <b-form-input v-model="door.id" type="text"/>
                    <label for="phone">Door ID</label>
                  </div>
                </div>
              </div>
              </div>
            </div> -->

            <!-- <div id="kioskContainer" v-show="this.typeValue=='Kiosk'">
                <p class="company-details">Kiosk details</p> -->
                <!-- device select  -->
                <!-- <div class="company-input select-device">
                  <div class="input-wrapper">
                    <multiselect id="server" class="custom-multi-select" v-model="device" :options="deviceOptions"
                      placeholder="Purchased Device" label="name" :show-labels="false" :allowEmpty="true"
                      @select="addLamasatechSerial" />
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.server.required">
                      <span class="error-value">Purchased device is required.</span>
                    </div>
                  </div>
                </div>
                <div class="row-group kiosk-date-wrapper"> -->
                  <!-- kiosk name  -->
                  <!-- <div class="kiosk-name">
                    <div class="input-wrapper">
                      <div class="form-group m-d-gruop" :class="$v.kiosk.name.$error && 'invalid-value'">
                        <b-form-input v-model="kiosk.name" type="text" />
                        <label for="phone">Kiosk Name</label>
                      </div>
                    </div>
                    <div class="err-wrapper">
                      <div class="mb-0" v-if="submitted && !$v.kiosk.name.required">
                        <span class="error-value">Kiosk name is required</span>
                      </div>
                      <div class="mb-0" v-else-if="submitted && !$v.kiosk.name.maxLength">
                        <span class="error-value">The maximum length is 30 characters</span>
                      </div>
                    </div>
                  </div> -->
                  <!-- date  -->
                  <!-- <div class="purchase-date">
                    <div class="input-wrapper">
                      <div class="form-group m-d-gruop" :class="$v.kiosk.date_of_purchase.$error && 'invalid-value'">
                        <date-picker class="w-100" id="custom-date-picker" v-model="kiosk.date_of_purchase" :first-day-of-week="1"
                          lang="en" placeholder="Purchase Date" value-type="format" format="YYYY-MM-DD"></date-picker>
                      </div>
                    </div>
                    <div class="err-wrapper">
                      <div class="mb-0" v-if="submitted && !$v.kiosk.date_of_purchase.required">
                        <span class="error-value mb-0">Purchase Date is required.</span>
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- android serial  -->
                <!-- <div class="android-serial company-input">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop input-icons" :class="$v.kiosk.android_serial.$error && 'invalid-value'">
                      <b-form-input class="input-field" v-model="kiosk.android_serial" type="text" />
                      <i :class="{'show-icon': !$v.kiosk.android_serial.$invalid, 'hide-icon': $v.kiosk.android_serial.$invalid}" class="icon fa fa-check"></i>
                      <label for="phone">Android Serial Number</label>
                    </div>
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.kiosk.android_serial.required">
                      <span class="error-value">
                        Android Serial number is required.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.android_serial.alphaNum">
                      <span class="error-value">Please enter Android Serial alphaNum.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.android_serial.minLength">
                      <span class="error-value">Android Serial should be at least 10 charcters.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.android_serial.containsUppercase">
                      <span class="error-value">Android Serial should contain capital letters only.</span>
                    </div>
                  </div>
                </div> -->
                <!-- mac_address  -->
                <!-- <div class="mac-address company-input">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop input-icons" :class="$v.kiosk.mac_address.$error && 'invalid-value'">
                      <b-form-input class="input-field" v-model="kiosk.mac_address" type="text" />
                      <i :class="{'show-icon': !$v.kiosk.mac_address.$invalid, 'hide-icon': $v.kiosk.mac_address.$invalid}" class="icon fa fa-check"></i>
                      <label for="phone">MAC Address</label>
                    </div>
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.kiosk.mac_address.required">
                      <span class="error-value">
                        MAC Address is required.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.mac_address.alphaNum">
                      <span class="error-value">Please enter MAC Address alphaNum.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.mac_address.minLength">
                      <span class="error-value">Please enter MAC Address 12 charcter.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.mac_address.containsUppercase">
                      <span class="error-value">MAC Address should contain capital letters only.</span>
                    </div>
                  </div>
                </div>
                <hr class="h-line mac-serial-line" /> -->
                <!-- lamasatech-serial  -->
                <!-- <div class="lamasatech-serial company-input">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop" :class="$v.kiosk.lamasatech_serial.$error && 'invalid-value'">
                      <b-form-input v-model="kiosk.lamasatech_serial" type="text" :disabled="!device" />
                      <label for="phone">LamasaTech Serial</label>
                    </div>
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.kiosk.lamasatech_serial.required">
                      <span class="error-value">
                        LamasaTech Serial is required.</span>
                    </div>
                    <div v-else-if="submitted && !$v.kiosk.lamasatech_serial.numeric">
                      <span class="error-value">
                        LamasaTech serial should be only numbers.</span>
                    </div>
                    <div v-else-if="submitted && !$v.kiosk.lamasatech_serial.minLength">
                      <span class="error-value">
                        LamasaTech serial should be at least 14 digits</span>
                    </div>
                  </div>
                </div> -->
                <!-- purchased from  -->
                <!-- <p class="purchased-from-text">Purchased from</p>
                <div class="d-flex align-items-center radio-check">
                  <b-form-radio class="text-muted" v-model="kiosk.purchased_from" value="LamasaTech">LamasaTech
                  </b-form-radio>
                  <b-form-radio class="mx-4 text-muted" v-model="kiosk.purchased_from" value="Partner">Partner
                  </b-form-radio>
                </div> -->
                <!-- parent name -->
                <!-- <div class="parent-name company-input" v-if="kiosk.purchased_from == 'Partner'">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop" :class="$v.kiosk.partner_name.$error && 'invalid-value'">
                      <b-form-input v-model="kiosk.partner_name" type="text" />
                      <label for="phone">Partner Name</label>
                    </div>
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.kiosk.partner_name.required">
                      <span class="error-value">Partner name is required</span>
                    </div>
                  </div>
                </div>
            </div>

            
          </tab-content> -->
          <p class="slot-prev mb-0" slot="prev">Back</p>
          <p :disabled="getLoading" class="slot-next mb-0" slot="next">
            Next
          </p>
          <b-button
            v-if="false"
            class="w-lg register-btn d-none"
            :disabled="getLoading"
            variant="primary"
            slot="finish"
          >
            <i
              v-if="getLoading"
              class="
                bx bx-hourglass bx-spin
                font-size-16
                align-middle
                mr-2
              "
            ></i>
            <span v-else>CREATE</span>
          </b-button>
        </form-wizard>

        <!-- <button
          class="btn btn-primary btn-block submit-btn"
          type="button"
          @click="onSubmit"
          :disabled="getLoading || disableSubmitBtn"
        >
          <i
            v-if="getLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span v-else>CREATE</span>
        </button> -->


        <!-- action btns  -->
        <hr class="h-line" />
        <div class="action-btns" style="width: 416px; margin:auto">
          <button class="submit-btn btn btn-primary" size="md"
            @click="onSubmit" :disabled="getLoading || disableSubmitBtn ">
            <i v-if="getLoading" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"></i>
            <span v-else>Create</span>
          </button>
          <button class="btn btn-outline-danger ml-32" @click="$bvModal.hide('createCompany')">
            Cancel
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  required,
  // alphaNum,
  numeric,
  minLength,
  maxLength,
  // requiredIf,
} from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import isValidDomain from "is-valid-domain";
import Multiselect from "vue-multiselect";
import VueCountryCode from "vue-country-code";
import "vue2-datepicker/index.css";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import { subdomainIssue, unavailableReasonFrom } from "@/utils/subdomainFeedback";
export default {
  name: "CreateCompany",
  components: {
    // DatePicker,
    Multiselect,
    VueCountryCode,
    FormWizard,
    TabContent,
  },
  data() {
    return {
      typeValue: '',
      typeOptions: ['Kiosk', 'Door'],
      servers: [],
      server: null,
      device: "",
      userId: null,
      companyCountryCode: null,
      deviceOptions: [
        { id: "LT-Zentron8", name: "LT-Zentron8" },
        { id: "LD-AITemp", name: "LD-AITemp" },
        { id: "Zentron 15", name: "Zentron 15" },
      ],
      entity: {
        name: null,
        subdomain: null,
        company_phone: null,
        package: "Standalone",
      },
      name: "",
      // door: {
      //   name: null,
      //   id: null,
      // },
      // kiosk: {
      //   name: null,
      //   mac_address: null,
      //   lamasatech_serial: null,
      //   date_of_purchase: null,
      //   android_serial: null,
      //   purchased_from: "LamasaTech",
      //   partner_name: null,
      // },
      submitted: false,
      subdomainInputTyping: false,
      subdomain: "",
      phone: null,
      subdomainValue: null,
      phone_input: null,
      phoneInputTyping: false,
      openKioskInfo: false,
      terms_and_conditions: false,
      subdomainInputValid: null,
      // CL-18308: WHY the subdomain is unavailable -- 'taken' or 'reserved'.
      // null whenever availability is unknown or the name is free.
      subdomainUnavailableReason: null,
    };
  },
  validations: {
    entity: {
      name: { required, maxLength: maxLength(50) },
      subdomain: { 
        required,
       },
      company_phone: { numeric },
      package: { required },
    },
    // door: {
    //   name: {
    //     required: requiredIf(function() {
    //       return this.typeValue == 'Door';
    //     }) , maxLength: maxLength(30) },
    //   id: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Door';
    //     }), maxLength: maxLength(25) },
    // },
    // kiosk: {
      
    //   name: {
    //     required: requiredIf(function () {
    //       console.log('inside name requiredif ',this.typeValue);
    //       return this.typeValue == 'Kiosk';
    //     }),  maxLength: maxLength(30) },
    //   date_of_purchase: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Kiosk';
    //     }) },
    //   android_serial: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Kiosk';
    //     }),
    //     alphaNum,
    //     minLength: minLength(10),
    //     containsUppercase: function(value) {
    //       return (/^[A-Z0-9]*$/).test(value)
    //     },
    //   },
    //   mac_address: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Kiosk';
    //     }),
    //     alphaNum,
    //     minLength: minLength(12),
    //     containsUppercase: function(value) {
    //       return (/^[A-Z0-9]*$/).test(value)
    //     },
    //   },
    //   partner_name: { 
    //     required: requiredIf(function() {
    //       const { kiosk:{purchased_from} } = this;
    //       return purchased_from == 'Partner' && this.typeValue == 'Kiosk' ? true : false;
    //     })
    //      },
    //   lamasatech_serial: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Kiosk';
    //     }),
    //     numeric,
    //     minLength: minLength(14),
    //   },
    // },
    subdomainValue: { 
      required,
      minLength: minLength(3),
      maxLength: maxLength(63),
      containsSpace: function(value) {
        return !/[^a-zA-Z0-9-]/.test(value);
      },
      validCharacters: function(value) {
        return /^[a-z0-9-]+$/.test(value);
      },
      containsHyphenAtStart: function(value) {
        return !(value.startsWith('-') || value.endsWith('-'));
      },
      containsDoubleHyphen: function(value) {
        return !value.includes('--');
      },
     },
    phone: { numeric },
    // device: {
    //   required: requiredIf(function () {
    //     return this.typeValue == 'Kiosk';
    //   }) },
    phone_input: { numeric, maxLength: maxLength(15) },
    server: { required },
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("createCompany");
    },
    server(server) {
      if (server) {
        let domain = server.server_name;
        if (domain.indexOf("https://") > -1)
          domain = domain.replace("https://", "");

        if (domain.indexOf("http://") > -1) {
          domain = domain.replace("http://", "");
        }
        this.subdomain = "." + domain;
      } else {
        this.subdomainValue = null;
      }
    },
    // device(device) {
    //   if (!device || device.length == 0) {
    //     this.kiosk.lamasatech_serial = null;
    //   }
    // },
    getServer(getServer) {
      this.servers = JSON.parse(JSON.stringify(getServer));
    },

    subdomainValue(subdomainValue) {
      this.subdomainInputValid = null;
      this.subdomainUnavailableReason = null;

      if (
        (subdomainValue && subdomainValue.includes(".")) ||
        (subdomainValue && subdomainValue.includes("_"))
      ) {
        // CL-18307: this value is not checkable, so abandon anything already
        // scheduled or in flight for the PREVIOUS value. Returning without
        // cancelling let a probe for "acme" land after the box had been edited
        // to "acme." and paint its verdict next to the invalid value.
        this.cancelEntitySubdomainCheck();
        return false;
      }
      const completeSubdomain = `${subdomainValue}${this.subdomain}`
        .replace(/\s/g, "")
        .toLowerCase();
      const validSubdomain = isValidDomain(completeSubdomain, {
        subdomain: true,
        wildcard: false,
      });
      if (subdomainValue && validSubdomain && this.$v.subdomainValue.required && this.$v.subdomainValue.minLength && this.$v.subdomainValue.maxLength
          && this.$v.subdomainValue.validCharacters && this.$v.subdomainValue.containsSpace
          && this.$v.subdomainValue.containsHyphenAtStart && this.$v.subdomainValue.containsDoubleHyphen) {
        this.entity.subdomain = completeSubdomain;
        this.subdomainInputTyping = true;
        this.checkEntitySubdomain({
          subdomain: completeSubdomain,
          server: this.server,
        })
          .then((outcome) => {
            // CL-18307: the action now resolves an outcome. A superseded probe
            // must leave the flag exactly as it is -- `subdomainInputValid` was
            // reset to null at the top of this watcher, so the field correctly
            // reads as "not answered yet" while the newest probe is in flight.
            // Treating a supersede as `false` is what made the field flash
            // "taken" at values the user had already typed past.
            if (!outcome || outcome.superseded) {
              return;
            }
            const body = (outcome.result && outcome.result.data) || {};
            this.subdomainInputValid = !!body.data;
            // CL-18308: the backend now says WHY (vp5-back #3296). Falling
            // back to 'taken' rather than null keeps this screen correct
            // against a backend that does not send `reason` yet: taken was
            // always the overwhelmingly common case, and it is the case the
            // ticket is about. Reserved simply lights up once the backend half
            // lands, so neither PR blocks the other.
            this.subdomainUnavailableReason = unavailableReasonFrom(body);
          })
          .catch(() => {
            this.subdomainUnavailableReason = null;
            // A probe that genuinely failed (network, timeout, a 401 that
            // survived ClientApi's retry) tells us nothing about availability,
            // so the flag stays null: unknown, and the submit gate stays shut
            // because `disableSubmitBtn` requires it to be exactly true.
            // Previously this chain had no catch at all, so every failed probe
            // became an unhandled rejection in the console.
            this.subdomainInputValid = null;
          });
      } else {
        this.cancelEntitySubdomainCheck();
      }
    },
    getIsValidSubdomain(value) {
      if (this.checkSubdomain && value) {
        this.openKioskInfo = true;
      } else this.openKioskInfo = false;
    },
    checkSubdomain(value) {
      if (this.getIsValidSubdomain && value) {
        this.openKioskInfo = true;
      } else this.openKioskInfo = false;
    }
  },
  computed: {
    ...mapGetters("entity", [
      "getLoading",
      "getIsValidSubdomain",
      "getModalState",
    ]),
    ...mapGetters("authfack", ["userDetails", "getPhoneDuplicatedCheck"]),
    ...mapGetters("server", ["getServer"]),
    checkSubdomain() {
      if (
        (this.subdomainValue && this.subdomainValue.includes(".")) ||
        (this.subdomainValue && this.subdomainValue.includes("_"))
      )
        return false;
      const completeSubdomain = `${this.subdomainValue}${this.subdomain}`
        .replace(/\s/g, "")
        .toLowerCase();
      const validSubdomain = isValidDomain(completeSubdomain, {
        subdomain: true,
        wildcard: false,
      });
      return validSubdomain ? true : false;
    },
    /**
     * CL-18308: does the typed value satisfy every FORMAT rule?
     *
     * Availability is deliberately NOT part of this. The two were ANDed
     * together in the template, into a single condition whose only failure
     * message was "Invalid subdomain format." -- so a perfectly well-formed
     * subdomain that happened to be taken was reported as a format error.
     * Separating the two predicates is the fix.
     */
    subdomainFormatValid() {
      const v = this.$v.subdomainValue;

      return !!(
        v.required &&
        v.minLength &&
        v.maxLength &&
        v.validCharacters &&
        !v.containsSpace &&
        !v.containsHyphenAtStart &&
        !v.containsDoubleHyphen
      );
    },
    /**
     * CL-18308: the one problem to show the user, or null when there is none.
     *
     * Three distinct outcomes, in the order they can be known. Format is
     * checked locally and first, because there is no point asking the server
     * about a value that cannot be a subdomain. Only then does availability
     * matter, and a reserved name is its own answer rather than being folded
     * into "already used" -- telling a user that someone else owns `api` when
     * nobody owns it is the same class of wrong message as this ticket.
     */
    subdomainIssueMessage() {
      if (!this.server || !this.subdomainValue || !this.subdomainInputTyping) {
        return null;
      }

      // Delegated so the two Add Company screens cannot drift apart on
      // wording or on precedence -- the duplication is what let this bug
      // exist on one screen while modal/CreateCompanyModal.vue still had the
      // distinction. See src/utils/subdomainFeedback.js.
      return subdomainIssue({
        formatValid: this.subdomainFormatValid,
        available: this.subdomainInputValid,
        reason: this.subdomainUnavailableReason,
      });
    },
    disableSubmitBtn() {
      const { entity, terms_and_conditions } = this;
      return !(entity.name && entity.subdomain && terms_and_conditions && this.$v.subdomainValue.required && this.$v.subdomainValue.minLength && this.$v.subdomainValue.maxLength
          && this.$v.subdomainValue.validCharacters && this.$v.subdomainValue.containsSpace
          && this.$v.subdomainValue.containsHyphenAtStart && this.$v.subdomainValue.containsDoubleHyphen
          && this.subdomainInputValid == true
        );
    },
  },
  methods: {
    ...mapActions("entity", [
      "createEntity",
      "checkEntitySubdomain",
      "cancelEntitySubdomainCheck",
      "resetState",
    ]),
    ...mapActions("entities", [
      "fetchUserEntities",
    ]),
    ...mapActions("server", ["getServers"]),
    onSubmit() {
      console.log(this.typeValue);
      this.submitted = true;
      this.$v.$touch();
      console.log("after touch() line 597");
      this.entity.subdomain = null;
      this.entity.company_phone = null;
      this.entity.company_phone =
        this.phone && this.phone > 0
          ? `${this.companyCountryCode}${this.phone}`
          : null;
      this.entity.subdomain = this.subdomainValue + this.subdomain;
      // stop here if form is invalid
      console.log('stop here if form is invalid');
      console.log(this.$v);
      if (!this.$v.$invalid) {
        console.log('before submit');
        const { entity, typeValue } = this;
        if (this.checkSubdomain && this.getIsValidSubdomain) {
          
          this.createEntity({
            user: { passport_id: this.userId },
            entity,
            // kiosk,
            // door,
            typeValue,
            // lamasatech_serial: { id: kiosk.lamasatech_serial },
            server: this.server,
          }).then(() => {
            this.$toast.success(this.$t('form.entityCreated'));
            this.fetchUserEntities();
          });
        } else {
          this.$toast.error("Please add a valid subdomain!.", {
            position: "top-right",
          });
        }
      }
    },
    addLamasatechSerial(selectedOption) {
      switch (selectedOption.name) {
        case "LD-AITemp":
          return (this.kiosk.lamasatech_serial = "7091135919162XXXXX");
        case "LT-Zentron8":
          return (this.kiosk.lamasatech_serial = "7091136435555XXXXX");
        case "Zentron 15":
          return (this.kiosk.lamasatech_serial = "5060861160027XXXXX");
        default:
          "";
      }
    },
    onSubdomainInputTyping() {
      return (this.subdomainInputTyping = true);
    },
    onSubdomainInputPaste() {
      return (this.subdomainInputTyping = true);
    },
    onSelectCompanyCountryCode({ dialCode }) {
      this.companyCountryCode = dialCode;
    },
    beforeTabOneSwitch() {
      this.subdomainInputTyping = true;
      if (!this.$v.entity.$invalid && !this.$v.subdomainValue.$invalid && !this.$v.server.$invalid) {
        this.$v.$reset();
        this.submitted = false;
      } else {
        this.$v.$touch();
        this.submitted = true;
        return;
      }
      if (this.checkSubdomain && this.getIsValidSubdomain) {
        return new Promise((resolve) => {
          this.openKioskInfo = true;
          resolve(!this.$v.entity.$invalid);
        });
      }
    },
    beforeTabTwoSwitch() {
      console.log('inside beforeTabTwoSwitch');
      if (!this.$v.form.kiosk.$invalid) {
        alert('invalid kiosk form');
        this.$v.$reset();
        this.submitted = false;
      } else {
        this.$v.$touch();
        this.submitted = true;
      }
      return new Promise((resolve) => {
        resolve(!this.$v.form.kiosk.$invalid);
      });
    },
    onPhoneInputTyping() {
      return (this.phoneInputTyping = true);
    },
    onTypeChange(value) {
      this.typeValue = value
      console.log(this.typeValue);
    },
    changeServerVal() {
      this.subdomainValue = null;
    }
  },
  beforeMount() {
    this.resetState();
    this.getServers();
  },
  mounted() {
    this.userId = JSON.parse(localStorage.getItem("user")).data.user.id;
  },
};
</script>

<style lang="scss" scoped>
.show-icon {
  display: block !important;
}
.hide-icon {
  display: none !important;
}
.input-icons i {
  position: relative;
  float: right;
  padding-right: 15px;
}
  
.input-icons {
  width: 100%;
  margin-bottom: 10px;
}
  
.icon {
  // padding: 10px;
  margin: -16px;
  color: #34c38f;
  min-width: 50px;
  text-align: center;
}
  
.input-field {
  width: 100%;
  padding: 10px;
  // text-align: center;
}

.company-form {
  .header {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    margin-bottom: 17px;
    img {
      margin-bottom: 18px;
    }
  }
  .company-details {
    font-weight: 700;
    font-size: 16px;
    color: #787878;
  }
  .company-input {
    margin-bottom: 16px;
    width: 100%;
    .input-wrapper {
      height: 55px;
      display: flex;
      align-items: center;
    }
  }
  .kiosk-date-wrapper {
      margin-bottom: 17px;
  }
  .select-server,
  .select-device {
    .input-wrapper {
      display: flex;
      align-items: center;
      background-color: #f3f3f3;
    }
  }
  .date_of_purchase {
    height: 55px;
  }
  .row-group {
    display: flex;
    justify-content: space-between;
  }
  .phone-input-wrapper {
    display: grid;
    grid-template-columns: 20% 80%;
  }
  .phone-input {
    border-radius: 0px 0.25rem 0.25rem 0px;
  }
  .kiosk-name {
    margin-right: 16px;
  }
  .mac-serial-line {
    margin: 15px 0 !important;
  }
  .purchased-from-text {
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 0.25px;
    color: #787878;
    margin-bottom: 29px;
  }
  .radio-check,
  .purchased-from-text {
    padding-left: 20px;
  }
  .radio-check{
    margin-bottom: 5px;
  }
}

.mb-111{
  margin-bottom: 111px !important;
}

.mt-6{
  margin-top: -6px !important;
}



.subdomain-input{
  border-start-end-radius: 0px !important;
  border-end-end-radius: 0px !important;
}

.custom-multiselect-title{
  font-family: Lato;
  font-weight: 700;
  font-size: 12px;
  color: #103F5E;
  z-index: 1 !important;
}


.pl-24 {
  padding-left: 24px !important;
}

.ml-51{
  margin-left: 51px !important;
}

.mt-12{
  margin-top: 12px !important;
}

.select-server{
  position: relative;
}

.terms_and_conditions-checkbox {
  margin-top: 24px !important;
  font-family: Lato;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color : #787878;
}

.terms_and_conditions-checkbox-checked{
  color: #103F5E !important;
  font-weight: 700 !important;
}

.subdomain-requirements-container{
  align-items: center;
  margin-top: 8px;
  margin-left: 20px;
}

.disabled-subdomain-requirements-container{
  align-items: center;
  margin-top: 8px;
  margin-left: 20px;
  cursor: not-allowed; //cursor-not-allowed
  pointer-events: none;
}

.subdomain-requirements-icon{
  margin-right: 8px;
  cursor: pointer !important;

  &:focus{
    outline: none;
  }
}  

.disabled-subdomain-label {
  color: #C1C1C1 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}

.disabled-subdomain-input {
  color: #C1C1C1 !important;
}

.invalid-value-subdomain {
  border: 1.5px solid #F46A6A !important;
  border-right: none !important;
}
.invalid-value-subdomain-name {
  border: 1.5px solid #F46A6A !important;
  border-left: none !important;
}
.subdomain-requirements-label{
  font-family: Lato !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 22px !important;
  color: #787878;
}

.subdomain-requirements-label-error {
  color: #F46A6A !important;
  font-family: Lato;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}

</style>

<style lang="scss">

  div#createCompany___BV_modal_content_ {

    .modal-main-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 40px;
      margin-left: 125px;
      .company-title {
        color: #000;
        font-size: 17px;
        font-weight: 700;
        line-height: normal;
        line-height: 100%;
        text-align: center;
        margin-bottom: 24px;
      }

      .company-subtitle {
        font-weight: 700;
        font-size: 16px;
        color: #787878;
        text-align: center;
      }

      .header-close{
        margin: -8px -10px; 
        cursor: pointer;
      }
    }

    .custom-form-wizard {
      min-height: 0px;
    }

    .custom-form-wizard .wizard-tab-content {
      margin-bottom: 0px ;
    }
    .h-line{
      margin-top: 40px;
      margin-bottom: 24px;
    }
    button.submit-btn.btn.btn-primary{
      color: #ffffff!important;
      font-size: 16px;
     
     margin-right: 0px!important;
      font-weight: 400;
      &:disabled{
        background-color: #9FB2BF;
        border-color: #9FB2BF;
      }
    }

    .tooltip {
      position: fixed !important;
      top: 358px !important;
      left: 527px !important;
      border-radius: 6px;
      box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05) !important; 
      background-color: #FFFFFF !important;
      padding: 0px !important;
      .tooltip-inner {
        width: 302px !important;
        max-width: 302px !important;
        color: #787878 !important;
        padding: 16px !important;  
        background-color: #FFFFFF !important;
        overflow-y: auto;
        height: 300px;
      }
      .arrow{
        display: none !important;
      }

      .subdomain-requirements{
        text-align: left;
        
      }

      .subdomain-requirements-title{
        font-family: Lato;
        font-weight: 700;
        font-size: 12px;
        line-height: 17px;
        color: #787878;
        text-align: left;
      }

      .subdomain-requirements-items-container{
        margin-top: 13px;
      }

      .subdomain-requirements-item{
        font-family: Lato;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #787878;      
      }

      .subdomain-requirements-hr{
        margin-top: 10px;
        margin-bottom: 10px;
        color: #EBEBEB;
        border: 1px solid #EBEBEB
      }


      .success-requirements-item{
        color: #34C38F !important;
        font-weight: 700 !important;
      }

      .failure-requirements-item{
        color : #F46A6A !important;
        font-weight: 700 !important;
      }
      
    }
  }

</style>
